<template>
  <v-container   class="pa-4 mt-10 mx-auto ">
  <div class="brick">
    <div class="brick-inner">
      <!-- Image Section -->
     
      <div class="brick-img">
        <img :src="image" alt="Product Image" />
        <span class="price-tag">Rs. {{ price }}</span>
      </div>

      <!-- Content Section -->
      <div class="brick-content">
        <div class="brick__content-upper">
          <h3 class="brick__title">{{ title }}</h3>
          <span class="brick__tagline">{{ subtitle }}</span>
          <!-- <span v-html="subtitle"></span> -->

        </div>
        <div class="brick__caption-lower">
          <!-- <RouterLink to="/contact" class="text-decoration-none order-btn"> Enquiry Now</RouterLink> -->
          <button class="order-btn">Order Now</button>
        </div>
      </div>
    </div>
  </div>
</v-container>
</template>

<script setup>
defineProps({
  title: String,
  subtitle: String,
  price: String,
  image: String,
});
</script>

<style scoped>
/* Card container */
.brick {
  margin-bottom: 30px;
  width: 100%;
  max-width: 320px;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

/* Inner card with hover effect */
.brick-inner {
  display: flex;
  flex-direction: column;
  height: 380px; /* Ensures all cards are the same height */
  border-radius: 12px;
  overflow: hidden;
  background-color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.brick-inner:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

/* Image styling */
.brick-img {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.brick-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease-in-out;
}

.brick-inner:hover .brick-img img {
  transform: scale(1.1);
}

/* Price tag */
.price-tag {
  position: absolute;
  top: 160px;
  right: 10px;
  background: #0084ff;
  color: white;
  font-size: 14px;
  font-weight: bold;
  padding: 5px 12px;
  border-radius: 8px;
}

.brick-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1; 
  padding: 15px;
  text-align: center;
}
.brick__title {
  font-size: 18px;
  font-weight: 700; /* Use 700 for bold font weight */
  color: #333;
  margin-bottom: 5px;
  text-align: left;
}


.brick__tagline {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  text-align: left;
  max-height: 2.8em; 
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

.order-btn {
  margin-top: 10px;
  padding: 10px 16px;
  width: 100%;
  font-size: 15px;
  font-weight: bold;
  background: #629ce7;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}

.order-btn:hover {
  background: #007fe6;
}
</style>